'use strict';
import React from 'react';

export function AgendaAssignment(assignedTo) {
  return (
    <span className="org-calendar-agenda-label">
      <span className="space-after">
        Assigned To:
      </span>
      {assignedTo ? (
        <a href={`#/app/personnel/${assignedTo.collection}-detail/${assignedTo.id}`}>
          {assignedTo.name}
        </a>
      ) : '-'}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/AgendaAssignment.js